// main-widget-registry.js
import NumberUnit1Widget from "./widget/number-unit-1";
import Toggle1Widget from "./widget/toggle-1";
import Select1Widget from "./widget/select-1";
import MultiSelect1Widget from "./widget/multi-select-1";
import Text1Widget from "./widget/text-1";
import Time1Widget from "./widget/time-1";
import Date1Widget from "./widget/date-1";
import DateTime1Widget from "./widget/date-time-1";
import Brightness1Widget from "./twin-widget/brightness-1";
import Color1Widget from "./twin-widget/color-1";
import OnOffBrightnessColor1Widget from "./twin-widget/onoff-brightness-color-1";
import Illuminance1Widget from "./twin-widget/illuminance-1";
import OnOff1Widget from "./twin-widget/onOff-1";
import Motion1Widget from "./twin-widget/motion-1";
import Present1Widget from "./twin-widget/present-1";
import Online1Widget from "./twin-widget/online-1";
import ButtonPress1Widget from "./twin-widget/buttonPress-1";
import ContactSensor1Widget from "./twin-widget/contact-sensor-1";
import Temperature1Widget from "./twin-widget/temperature-1";
import Humidity1Widget from "./twin-widget/humidity-1";
import VolumeMute1Widget from "./twin-widget/volume-mute-1";
import MediaPlayback1Widget from "./twin-widget/media-playback-1";
import WindowOpenClose1Widget from "./twin-widget/window-open-close-1";
import Lock1Widget from "./twin-widget/lock-1";
import Fan1Widget from "./twin-widget/fan-1";
import Thermostat1Widget from "./twin-widget/thermostat-1";
import Number1Widget from "./widget/number-1";
import BrightnessNumber1Widget from "./tag/brightness-number-1";
import ColorTempNumber1Widget from "./tag/colorTemp-number-1";
import Unsupported1Widget from "./widget/unsupported-1";
import DynamicWidgetRenderer from "./widget/dynamic-widget-render";

const mainWidgetMap = new Map();

// Register data widgets without handler
export const registerMainWidgets = () => {
  mainWidgetMap.set("default.toggle", Toggle1Widget);
  mainWidgetMap.set("default.bool", Toggle1Widget);
  mainWidgetMap.set("default.number", Number1Widget);
  mainWidgetMap.set("default.select", Select1Widget);
  mainWidgetMap.set("default.multiSelect", MultiSelect1Widget);
  mainWidgetMap.set("default.select[]", MultiSelect1Widget);
  mainWidgetMap.set("default.text", Text1Widget);
  mainWidgetMap.set("default.string", Text1Widget);
  mainWidgetMap.set("default.timeGeneral", Time1Widget);
  mainWidgetMap.set("default.dateGeneral", Date1Widget);
  mainWidgetMap.set("default.timestamp", DateTime1Widget);

  // twin
  mainWidgetMap.set(
    "default.basic.device.onoff_brightness_color",
    OnOffBrightnessColor1Widget
  );
  mainWidgetMap.set("default.basic.device.brightness", Brightness1Widget);
  mainWidgetMap.set("default.basic.device.color", Color1Widget);
  mainWidgetMap.set("default.basic.device.onoff", OnOff1Widget);
  mainWidgetMap.set("default.basic.device.motion", Motion1Widget);
  mainWidgetMap.set("default.basic.device.presence", Present1Widget);
  mainWidgetMap.set("default.basic.device.online", Online1Widget);
  mainWidgetMap.set("default.basic.device.buttonPress", ButtonPress1Widget);
  mainWidgetMap.set("default.basic.device.contactsensor", ContactSensor1Widget);
  mainWidgetMap.set("default.basic.device.temperature", Temperature1Widget);
  mainWidgetMap.set("default.basic.device.humidity", Humidity1Widget);
  mainWidgetMap.set("default.basic.device.illuminance", Illuminance1Widget);
  mainWidgetMap.set("default.basic.device.audioVolumeMute", VolumeMute1Widget);
  mainWidgetMap.set("default.basic.device.mediaPlayback", MediaPlayback1Widget);
  mainWidgetMap.set(
    "default.basic.device.windowopenclose",
    WindowOpenClose1Widget
  );
  mainWidgetMap.set("default.basic.device.lockUnlock", Lock1Widget);
  mainWidgetMap.set("default.basic.device.fan", Fan1Widget);
  mainWidgetMap.set("default.basic.device.thermostat", Thermostat1Widget);
  mainWidgetMap.set("default.numberUnit", NumberUnit1Widget);
  mainWidgetMap.set("default.duration", NumberUnit1Widget);
  mainWidgetMap.set("default.temperature", NumberUnit1Widget);
  mainWidgetMap.set("default.temperaturediff", NumberUnit1Widget);
  mainWidgetMap.set("default.weight", NumberUnit1Widget);
  mainWidgetMap.set("default.length", NumberUnit1Widget);

  // tag
  mainWidgetMap.set("default.brightness:number", BrightnessNumber1Widget);
  mainWidgetMap.set("default.colorTemperature:number", ColorTempNumber1Widget);
};

// Function to register custom data widgets
export const registerMainWidget = (skinName, WidgetComponent) => {
  mainWidgetMap.set(skinName, WidgetComponent);
};

// Function to get widget component
export const getMainWidgetComponent = (skin, componentCode) => {
  if (componentCode) {
    const DynamicWidgetComponent = (props) => (
      <DynamicWidgetRenderer code={componentCode} {...props} />
    );
    DynamicWidgetComponent.displayName = "DynamicWidgetComponent";
    return DynamicWidgetComponent;
  }
  const widgetComponent = mainWidgetMap.get(skin);

  if (!widgetComponent) {
    console.log("No widget component found for skin:", skin);
    return null;
  }
  return widgetComponent;
};
